// extracted by mini-css-extract-plugin
export default {"heading":"LoginInfoBox_heading__WN3jT","informationText":"LoginInfoBox_informationText__miDO+"};